import { useState, useCallback, useMemo } from 'react';
import { TaskTemplate } from 'utils/types/taskTemplate';

export const useTemplateSearch = (templates: TaskTemplate[]) => {
  const [searchParamValue, setSearchParamValue] = useState('');

  const handleSearch = useCallback((value: string) => {
    setSearchParamValue(value);
  }, []);

  const formattedTemplates = useMemo(
    () =>
      templates.filter((template) => {
        if (searchParamValue) {
          return (
            template.name
              ?.toLocaleLowerCase()
              .includes(searchParamValue.toLocaleLowerCase()) || false
          );
        }
        return true;
      }),
    [templates, searchParamValue]
  );

  return {
    searchParamValue,
    handleSearch,
    formattedTemplates,
  };
};
